import React, { FC } from 'react';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { IntroSkipButtonGroup } from './component';

interface FilterProps {
    contentId: string;
    className?: string;
    currentFragment: SkippableFragment | undefined;
}

export const IntroSkipButtonGroupContainer: FC<FilterProps> = ({ currentFragment, ...rest }) => {
    if (currentFragment && currentFragment?.type === 'INTRO') {
        return <IntroSkipButtonGroup currentFragment={currentFragment} {...rest} />;
    }

    return null;
};
